module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/153.20a33762.png";